

  <div class="w-full max-w-6xl grid gap-0 overflow-hidden rounded-2xl shadow-2xl"
       [class.grid-cols-1]="(isLessThanMD$ | async)"
       [class.grid-cols-2]="!(isLessThanMD$ | async)">

    <!-- Left Side - Image Section -->
    <div class="relative bg-cover bg-center min-h-[300px] md:min-h-[600px] flex flex-col justify-between p-8 md:p-12"
         [class.hidden]="(isHandset$ | async)"
         [style.background-image]="isSignUp() ? 'url(/images/solar-panel-signup.png)' : 'url(/images/solar-panel-signin.png)'">

      <!-- Logo -->
      <div>
        <img ngSrc="/logo_noya.png" alt="NOYA" class="h-12 w-auto" height="91" width="177" priority />
      </div>

      <!-- Text Content -->
      <div class="text-white">
        @if (isSignUp()) {
          <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight">
            Faites briller votre<br>avenir avec Noya Energy
          </h1>
        } @else {
          <h1 class="text-3xl md:text-4xl lg:text-5xl font-bold mb-4 leading-tight">
            Connectez-vous à votre<br>compte
          </h1>
        }
        <p class="text-sm md:text-base opacity-90">
          Rejoignez des milliers de foyers qui ont fait<br>
          le choix d'une énergie propre et durable avec<br>
          nos solutions photovoltaïques certifiées STEG
        </p>
      </div>
    </div>

    <!-- Right Side - Form Section -->
    <div class="bg-white p-8 md:p-12 flex flex-col justify-center">

      <!-- Mobile Logo (only visible on mobile) -->
      @if (isHandset$ | async) {
        <div class="mb-6">
          <img ngSrc="/logo_noya.png" alt="NOYA" class="h-10 w-auto mx-auto" height="91" width="177" priority />
        </div>
      }

      <!-- Form Header -->
      <div class="mb-8">
        <p class="text-xs md:text-sm text-primary font-semibold tracking-wider uppercase mb-2">
          INSCRIVEZ-VOUS ET GAGNEZ
        </p>
        <h2 class="text-2xl md:text-3xl font-bold text-neutral">
          @if (isSignUp()) {
            Créer un compte
          } @else {
            Se connecter à votre compte
          }
        </h2>
      </div>

      <!-- Sign Up Form -->
      @if (isSignUp()) {
        <form [formGroup]="signUpForm" (ngSubmit)="onSubmit()" class="space-y-4 mb-6">
          <!-- First Row: First Name and Last Name -->
          <div class="grid grid-cols-2 gap-3">
            <div>
              <input
                type="text"
                formControlName="firstName"
                placeholder="Prénom"
                class="w-full px-4 py-3 border border-outline rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
              />
              @if (signUpForm.get('firstName')?.invalid && signUpForm.get('firstName')?.touched) {
                <p class="text-error text-xs mt-1">Prénom requis</p>
              }
            </div>
            <div>
              <input
                type="text"
                formControlName="lastName"
                placeholder="Nom"
                class="w-full px-4 py-3 border border-outline rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
              />
              @if (signUpForm.get('lastName')?.invalid && signUpForm.get('lastName')?.touched) {
                <p class="text-error text-xs mt-1">Nom requis</p>
              }
            </div>
          </div>

          <!-- Second Row: Email alone -->
          <div>
            <input
              type="email"
              formControlName="email"
              placeholder="Email"
              class="w-full px-4 py-3 border border-outline rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
            />
            @if (signUpForm.get('email')?.invalid && signUpForm.get('email')?.touched) {
              <p class="text-error text-xs mt-1">Email valide requis</p>
            }
          </div>

          <!-- Third Row: Phone Number and Password -->
          <div class="grid grid-cols-2 gap-3">
            <div>
              <input
                type="tel"
                formControlName="phoneNumber"
                placeholder="Téléphone"
                class="w-full px-4 py-3 border border-outline rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
              />
              @if (signUpForm.get('phoneNumber')?.invalid && signUpForm.get('phoneNumber')?.touched) {
                <p class="text-error text-xs mt-1">Téléphone requis</p>
              }
            </div>
            <div>
              <input
                type="password"
                formControlName="password"
                placeholder="Mot de passe"
                class="w-full px-4 py-3 border border-outline rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
              />
              @if (signUpForm.get('password')?.invalid && signUpForm.get('password')?.touched) {
                <p class="text-error text-xs mt-1">Minimum 8 caractères</p>
              }
            </div>
          </div>

          <!-- Terms Checkbox -->
          <div class="flex items-start space-x-2">
            <input
              type="checkbox"
              formControlName="acceptTerms"
              id="terms"
              class="mt-1 h-4 w-4 text-primary border-outline rounded focus:ring-primary"
            />
            <label for="terms" class="text-sm text-neutral-variant">
              J'accepte les conditions générales d'utilisation
            </label>
          </div>

          <!-- Error Message -->
          @if (error()) {
            <div class="bg-error-container text-on-error-container px-4 py-3 rounded-lg text-sm">
              {{ error() }}
            </div>
          }

          <!-- Submit Button -->
          <button
            type="submit"
            [disabled]="!signUpForm.valid || loading()"
            class="w-full bg-secondary text-on-secondary py-3 rounded-lg font-semibold hover:opacity-90 transition-all disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            @if (loading()) {
              <mat-spinner diameter="20" color="accent"></mat-spinner>
              <span>Chargement...</span>
            } @else {
              <span>Découvrir</span>
            }
          </button>
        </form>
      }

      <!-- Sign In Form -->
      @if (!isSignUp()) {
        <form [formGroup]="signInForm" (ngSubmit)="onSubmit()" class="space-y-4 mb-6">
          <!-- Email -->
          <div>
            <input
              type="email"
              formControlName="email"
              placeholder="Email"
              class="w-full px-4 py-3 border border-outline rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
            />
            @if (signInForm.get('email')?.invalid && signInForm.get('email')?.touched) {
              <p class="text-error text-xs mt-1">Email valide requis</p>
            }
          </div>

          <!-- Password -->
          <div>
            <input
              type="password"
              formControlName="password"
              placeholder="Mot de passe"
              class="w-full px-4 py-3 border border-outline rounded-lg focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent transition-all"
            />
            @if (signInForm.get('password')?.invalid && signInForm.get('password')?.touched) {
              <p class="text-error text-xs mt-1">Minimum 8 caractères requis</p>
            }
          </div>

          <!-- Forgot Password Link -->
          <div class="text-right">
            <a   (click)="openForgotPassword()" class="text-sm text-secondary hover:underline">
              Mot de passe oublié ?
            </a>
          </div>

          <!-- Submit Button -->
          <button
            type="submit"
            [disabled]="!signInForm.valid"
            class="w-full bg-secondary text-on-secondary py-3 rounded-lg font-semibold hover:opacity-90 transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            Valider
          </button>
        </form>
      }

      <!-- Toggle Auth Mode -->
      <div class="text-center">
        @if (isSignUp()) {
          <p class="text-sm text-neutral-variant">
            Vous avez un compte ?
            <button type="button" (click)="toggleAuthMode()" class="text-secondary font-semibold hover:underline ml-1">
              Se connecter
            </button>
          </p>
        } @else {
          <p class="text-sm text-neutral-variant">
            Nouveau client ici ?
            <button type="button" (click)="toggleAuthMode()" class="text-secondary font-semibold hover:underline ml-1">
              Inscription rapide
            </button>
          </p>
        }
      </div>
    </div>
  </div>

